/* TODO: This file needs moved elsewhere when we renovate the Account & Profile pages, most of which
 * are currently in the legacy app */

import { Users } from '@platform/client';
import { Alert, Button, Input } from '@platform/components';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';

const UpdateYourEmail = () => {
  const userData = Users.useGetCurrentUser();
  const queryClient = useQueryClient();
  const updateEmail = Users.useUpdateEmail({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [...Users.getGetCurrentUserQueryKey()],
        });

        location.href = `${import.meta.env.VITE_API_HOST}/login/logout`;
      },
    },
  });
  const [newEmail, setNewEmail] = useState('');
  const [emailError, setEmailError] = useState<string | undefined>(undefined);
  const [touched, setTouched] = useState(false);

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setTouched(true);
    if (e.target.type === 'email' && !e.target.validity.valid) {
      setEmailError('Please enter a valid email address.');
    } else {
      setEmailError(undefined);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewEmail(e.target.value);
    if (touched) {
      setEmailError(undefined); // Clear error on change after blur
    }
  };

  const submit = () => {
    if (!newEmail?.length || emailError) {
      return;
    }

    updateEmail.mutate({
      data: {
        newEmail: newEmail.trim(),
      },
    });
  };

  if (!userData.isSuccess) {
    return (
      <div className='p-10 flex flex-col gap-4'>
        <Skeleton width={300} />
        <Skeleton width={300} />
      </div>
    );
  }

  return (
    <div className='p-10 flex flex-col gap-4'>
      <div className='text-2xl'>Update Your Email</div>
      <div className='max-w-96'>
        <Input
          type='inline'
          label='Existing Email'
          value={userData.data.userName}
          disabled
          onChange={() => {}}
        />
      </div>
      <div className='max-w-96'>
        {/* This max length is not enforced by our database, but emails in general should not
         * exceed 254 characters: https://stackoverflow.com/a/574698 */}
        <Input
          type='inline'
          inputType='email'
          label='New Email'
          value={newEmail}
          maxLength={254}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched ? emailError : undefined}
        />
      </div>
      <div className='mx-auto max-w-[800px] blue-links'>
        <Alert variant='info'>
          You will be logged out upon submitting and will receive an email at the new address
          detailing next steps. Please reach out to support at{' '}
          <a href='mailto:support@movingworlds.org'>support@movingworlds.org</a> if you are unable
          to access your account.
        </Alert>
      </div>
      <div className='mx-auto'>
        <Button
          variant='primary'
          size='lg'
          isDisabled={!!emailError || !newEmail || updateEmail.isPending}
          onPress={submit}
        >
          {updateEmail.isPending ? 'Submitting...' : 'Submit'}
        </Button>
      </div>
    </div>
  );
};

export default UpdateYourEmail;
